import Reveal from "./Reveal";

const SectionHeading = ({ eyebrow, title, className = "" }) => (
  <Reveal className={className}>
    <p className="flex items-center gap-4 text-xs uppercase tracking-[0.35em] text-cobalt font-medium" data-testid="section-eyebrow">
      <span className="h-px w-10 bg-cobalt/60" />
      {eyebrow}
    </p>
    <h2 className="mt-6 font-display text-3xl md:text-4xl tracking-tight text-ink max-w-2xl">
      {title}
    </h2>
  </Reveal>
);

export default SectionHeading;
